import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { Icon } from 'components/project/ClerkScreen';
import { StyledMessage } from './Styles';

const PinnedMessage = () => {
  const {
    AuctionStore: {
      auctionLaneId,
    },
    UIStore: { handleClearLanePinMessage },
    MessageStore: { messaging },
  } = useStores();

  const message = messaging.pinnedMessage.filter((item) => item.laneID === auctionLaneId);

  return message[0] && message[0].message && (
  <StyledMessage>
    <Icon
      icon="times"
      size={1.3}
      iconOnly
      onClick={() => handleClearLanePinMessage()}
    />
    {message[0].message}
  </StyledMessage>
  );
};

export default observer(PinnedMessage);
